import * as React from 'react'
function SvgMobileSend(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M30 4a4 4 0 014 4v24a4 4 0 01-4 4H14a4 4 0 01-4-4v-4a2 2 0 114 0v2h16V10H14v2a2 2 0 11-4 0V8a4 4 0 014-4zM18.2 15.4a1 1 0 011.4-.2l5.333 4a1 1 0 010 1.6l-5.333 4A1 1 0 0118 24v-2H8a2 2 0 110-4h10v-2a1 1 0 01.2-.6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgMobileSend
